"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var IngestionConfig = /** @class */ (function () {
    function IngestionConfig(BASE_URL, FUNCTIONS_KEY) {
        this.axios = axios_1.default.create({
            baseURL: BASE_URL
        });
        this.axios.defaults.headers.common["x-functions-key"] = FUNCTIONS_KEY;
        // Interceptors
        this.axios.interceptors.request.use(function (config) {
            var _a;
            var roleString = localStorage.getItem('role');
            var tokenString = localStorage.getItem('token');
            config.headers = ((_a = config.headers) !== null && _a !== void 0 ? _a : {});
            if (tokenString != null) {
                var token = JSON.parse(tokenString);
                config.headers.set("Authorization", "Bearer ".concat(token));
            }
            if (roleString != null && roleString !== undefined) {
                var role = JSON.parse(roleString);
                config.headers.set("Role", "".concat(role.role));
            }
            return config;
        });
        this.axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            if (error.response.status === 401) {
                // go to page login
                // history.push('login');
            }
            if (error.response.status === 403) {
                // go to page login
                // history.push('/inicio');
            }
            return Promise.reject(error);
        });
    }
    return IngestionConfig;
}());
exports.default = IngestionConfig;
